import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffRolesController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffRolesController.php:14
* @route 'https://org.proexpert.app/org/staff/{staffUser}/roles'
*/
export const update = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: 'https://org.proexpert.app/org/staff/{staffUser}/roles',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffRolesController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffRolesController.php:14
* @route 'https://org.proexpert.app/org/staff/{staffUser}/roles'
*/
update.url = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { staffUser: args }
    }

    if (Array.isArray(args)) {
        args = {
            staffUser: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        staffUser: args.staffUser,
    }

    return update.definition.url
            .replace('{staffUser}', parsedArgs.staffUser.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffRolesController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffRolesController.php:14
* @route 'https://org.proexpert.app/org/staff/{staffUser}/roles'
*/
update.put = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffRolesController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffRolesController.php:14
* @route 'https://org.proexpert.app/org/staff/{staffUser}/roles'
*/
const updateForm = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffRolesController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffRolesController.php:14
* @route 'https://org.proexpert.app/org/staff/{staffUser}/roles'
*/
updateForm.put = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

const roles = {
    update: Object.assign(update, update),
}

export default roles